export default __webpack_public_path__ + "static/media/591.6f766157.gif";